// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Table } from '@/ui';
import { Pagination } from '@/components';
import { StyledContentBlock, StyledPageWrapper } from '../Styled';
import { ImportsFiltersContainer } from '../../containers';
import { getImportsTableColumns } from './columns';

// Models
import { IProductsImportItem } from '@/models/productsImport.model';

type TImportsList = {
  importsList: IProductsImportItem[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
};

const ImportsList = ({ importsList, isLoading, currentPage, total, onPageChange }: TImportsList) => {
  const { t } = useTranslation(['products']);

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        <Table
          columns={getImportsTableColumns({ t })}
          dataSource={importsList || []}
          rowKey="id"
          loading={isLoading}
          components={{
            header: {
              wrapper: ImportsFiltersContainer,
            },
          }}
        />
      </StyledContentBlock>
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledPageWrapper>
  );
};

export default ImportsList;
